import instanceQuery from '../../../graphql/queries/bank/BankPaymentReceiptPostingPreviewQuery.graphql';
import fragment from '../../../graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const BankPaymentReceiptPostingPreview: EntityType = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default BankPaymentReceiptPostingPreview;
